import { type RefObject, useMemo } from 'react';

import { graphql, useLazyLoadQuery } from 'react-relay';

import { useAudioPlayerStore } from '../../hooks/useAudioPlayerStore';
import { usePlaylistAutoPlay } from '../../hooks/usePlaylistAutoPlay';
import type { PlaylistItemData } from '../playlist/PlaylistItem';

type AutoPlayManagerProps = {
	cloudId: string;
	audioElementRef: RefObject<HTMLAudioElement>;
};

export const AutoPlayManager = ({ cloudId, audioElementRef }: AutoPlayManagerProps) => {
	const { activeContent } = useAudioPlayerStore();

	const data = useLazyLoadQuery<any>(
		graphql`
			query AutoPlayManagerPlaylistQuery($cloudId: ID!) {
				confluence_getPlaylist(cloudId: $cloudId) {
					tracks {
						nodes {
							id
							type
							mainContent {
								id
								title
								type
								space {
									key
								}
								history {
									createdBy {
										displayName
									}
								}
							}
						}
					}
				}
			}
		`,
		{ cloudId },
		{
			fetchPolicy: 'store-or-network',
		},
	);

	const playlistItems: PlaylistItemData[] = useMemo(() => {
		const tracks = (data as any).confluence_getPlaylist?.tracks?.nodes || [];
		return tracks.map((track: any) => {
			const mainContent = track.mainContent;
			const creator = mainContent?.history?.createdBy;

			return {
				id: mainContent?.id,
				title: mainContent?.title || undefined,
				type: track.type,
				author: creator?.displayName || undefined,
				spaceKey: mainContent?.space?.key || '',
				contentType: mainContent?.type || '',
			};
		});
	}, [data]);

	// Enable auto-play of next track when current track ends
	usePlaylistAutoPlay({
		audioRef: audioElementRef,
		playlistItems,
		currentItemId: activeContent?.contentId,
	});

	return null;
};
